import userProfile from './slices';

const teamProfileReducer = userProfile.reducer;

export default teamProfileReducer;
